import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SettingService } from "./settings.service";
import { Router } from "@angular/router";
import { AppSettings } from "../../config/config";
import { LoginService } from "../login/login.service";
import { Offcanvas } from "../form.offcanvas";
import { FormValidator } from "../form.validator";
import { ScriptLoader } from "../script-loader";
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { BrandService } from '../brand/brand.service';

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var customToastr: any;

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: [
    './../../assets/css/theme-default/bootstrap.css',
    './../../assets/css/theme-default/materialadmin.css',
    './../../assets/css/theme-default/font-awesome.min.css',
    './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
    './../../assets/css/theme-default/material-design-iconic-font.min.css',
    './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
    /*'./../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
    './../../_crop/css/style.css',
    './../../_crop/css/style-example.css',
    './settings.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [LoginService, SettingService, Offcanvas, FormValidator, ScriptLoader]
})

export class SettingsComponent implements OnInit {

  academicPermissions: any;
  private langChangeSubscription: any;

  //schooldetails
  public schoolDetails = {};
  schoolName = "";
  schoolImage = "";
  accountType = "";
  totalStudent = "";
  phoneNumber = 0;
  address = "";
  emailId = "";
  parentChatMessageLimit = "";
  staffChatMessageLimit = "";
  description = "";

  //chat status
  parentChatStatus = true;
  staffChatStatus = true;
  parentChatMessageLimitCount = 0;
  staffChatMessageLimitCount = 0;

  parentChatStatusInput = true;
  staffChatStatusInput = true;
  GenerateStudentRegistrationId = false;

  //overviewdetails
  ActiveStaff = 0;
  InactiveStaff = 0;
  InactiveStudent = 0;
  ActiveStudent = 0;
  Employee = 0;
  AdminUser = 0;

  selecteduserId = 0;
  adminId = 0;

  //getaccdetails inactive student list

  studentName = "";
  parentName = "";
  mobileNumber = "";
  classNumber = "";
  reason = "";
  studentList = [];
  staffList = [];
  FeatureList = [];
  designation = "";
  staffName = "";
  PercentageActiveStaff = "";
  PercentageActiveStudent = "";
  PercentageInactiveStaff = "";
  PercentageInactiveStudent = "";

  currentPage: number = 1;
  pageSize: number = 10;
  pageSizeStudent: number = 10;
  totalPages: number = 0;
  totalRecords: number = 0;
  totalRecordsStudent: number = 0;
  hasNextPage: boolean = false;
  hasPreviousPage: boolean = false;
  startIndex: number = 0;
  searchLength: number = 0;
  searchStartIndex: number = 0;
  searchEndIndex: number = 0;
  endIndex: number = 0;
  startIndexStudent: number = 0;
  isSearch: boolean = false;
  isStudentSearch: boolean = false;
  searchEndStudent: number = 0;
  searchStartStudent: boolean = false;
  searchLengthStudent: number = 0;
  endIndexStudent: number = 0;
  searchTerm: string = '';
  searchStudentTerm: string = '';
  isPageLoading: boolean = false;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  currentSearchTerm: string = '';
  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();
  visiblePages: number[] = [];
  maxVisiblePages: number = 3; 
  studentSearch = new Subject<string>();
  currentSortBy: string = '';
  currentSortOrder: string = 'ASC';
  markAttendanceAfterCheckin: boolean = false;
  isMarkAttedanceAfterCheckInUpdating: boolean = false;

  // Feature Pagination
  allFeatures: any[] = [];
  pageSizeFeature: number = 10;
  currentPageFeature: number = 1;
  totalRecordsFeature: number = 0;
  totalPagesFeature: number = 0;
  startIndexFeature: number = 0;
  endIndexFeature: number = 0;
  paginatedFeatures = [];
  visiblePagesFeature: number[] = [];
  hasPreviousPageFeature: boolean = false;
  hasNextPageFeature: boolean = false;
  isFeatureSearch: boolean = false;
  searchFeatureTerm: string = '';
  filteredFeatures: any[] = [];
  selectedStatusFilter: string = 'All';
  statusFilterOptions: any[] = [
    { label: 'All', value: 'All' },
    { label: 'Enabled', value: 'ENABLED' },
    { label: 'Disabled', value: 'DISABLED' }
  ];
  featureSortField: string = 'BluewingsFeatureDescription';
  featureSortOrder: number = 1; // 1 for ascending, -1 for descending

  //token
  getSchoolId = localStorage.getItem('schoolinfo');
  getAdminType = localStorage.getItem('adminType');


  //featurelist

  bluewingsftrelst = [];
  //ActiveStatus = "";

  //updatefeaturelist
  pkSchoolFeatureId = "";

  //userlist
  userlst = [];
  getUlist;
  getfeaturelist;
  getUlistt;

  //updateschool
  updateschool = {
    schoolName: "",
    phoneNumber: "",
    emailId: "",
    address: "",
    address2: "",
    locality: "",
    state: "",
    pincode: "",
    description: "",
    parentChatMessageLimit: "",
    staffChatMessageLimit: ""
  };

  academicInfo = {
    current_academic: '',
    current_academic_state: '',
    current_tab: 'OVERVIEW',
    year: '',
    academicList: []
  };
  academicId: ""
  schoolAcademicList = [];
  schoolAcademicCurrent = [];
  schoolAcademicCurrentYear = [];

  //timezone 
  getTimeZoneArray = [];
  selectedTimeZoneId: number | null = null;
  selectedRegion: string = "Select Timezone";
  selectedTimezone;

  //adduser
  adduser = { emailId: "", username: "", password: "", cnfmpassword: "", PhoneNumber: "", AccessType: "" };
  featurelist = true;

  getuserdetails = { emailId: "", adminPhoneNumber: "", pkSchoolAdminsId: "", AdminAccessStatus: "", AccessType: "" };
  userPassword = "";
  //add user feature list
  getuserfeaturelist = [];
  getuserfeaturedetails = [];
  select = [];
  reactivatestudetails = { accountType: "", parentName: "", mobileNumber: "", emailId: "", reason: "", studentId: "" };
  usercnfmpassword = "";
  selecteduserIdForPswd = 0;
  isProcessing = false;
  brand = this.brandService.brand;

  constructor(private router: Router, private loginservice: LoginService, private settingservice: SettingService, private offcanvas: Offcanvas, private formValidator: FormValidator, private scriptLoader: ScriptLoader, private translate: TranslateService, private brandService: BrandService) {
      this.searchSubject.pipe(
      debounceTime(500), 
      distinctUntilChanged(),
      takeUntil(this.destroy$) 
    ).subscribe(searchTerm => {
      this.performSearch(searchTerm);
    });

      this.studentSearch.pipe(
      debounceTime(500), 
      distinctUntilChanged(), 
      takeUntil(this.destroy$) 
    ).subscribe(searchStudentTerm => {
      this.performStudentSearch(searchStudentTerm);
    });
  }
  getAuthToken = localStorage.getItem('usertoken');
  //token auth
  loginMode = "";
  isValidToken() {
    var isValidToken = false;
    var isValidSchool = 0;
    this.loginservice.isValidToken(localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          isValidToken = data.isValid;
          if (data.errorcode == 10010) {
            this.router.navigate(['/suspended']);
          }
          else if (isValidToken == true) {

            this.loginservice.isValidSchoolId(localStorage.getItem('schoolinfo'))
              .subscribe(
                (data: any) => {
                  isValidSchool = data.schoolExist;
                  this.getSchoolId = localStorage.getItem('schoolinfo');
                  if (isValidSchool != 1) {
                    this.router.navigate(['/login']);
                  }
                  else if (this.loginMode == "STAFF") {
                    this.router.navigate(['/exams']);
                  }
                  else {

                  }
                },
                error => {
                }
              );
          } else {
            this.router.navigate(['/login']);
          }
        },
        error => {

        }
      );
  }

  getSchoolDetails() {
    this.settingservice.fetchSchoolDetails()
      .subscribe(
        (data: any) => {

          this.schoolName = data.schoolName;
          this.schoolImage = data.schoolImage;
          this.accountType = data.accountType;
          this.totalStudent = data.totalStudent;
          this.phoneNumber = data.phoneNumber;
          this.address = data.address;
          this.emailId = data.emailId;
          this.parentChatMessageLimit = data.parentChatMessageLimit;
          this.staffChatMessageLimit = data.staffChatMessageLimit;
          this.description = data.description;
          this.GenerateStudentRegistrationId = data.GenerateStudentRegistrationId == 'AUTO';
          this.parentChatMessageLimitCount = data.parentChatMessageLimit;
          this.staffChatMessageLimitCount = data.staffChatMessageLimit;


          if (data.parentChatMessageLimit == 'UNLIMITED') {
            this.parentChatStatus = false;
            this.parentChatStatusInput = false;
          } else {
            this.parentChatStatus = true;
            this.parentChatStatusInput = true;
          }

          if (data.staffChatMessageLimit == 'UNLIMITED') {
            this.staffChatStatus = false;
            this.staffChatStatusInput = false;
          } else {
            this.staffChatStatus = true;
            this.staffChatStatusInput = true;
          }


        },
        error => {

        }
      );
  }

  getOverViewDetails() {

    this.settingservice.fetchOverViewDetails()
      .subscribe(
        (data: any) => {
          /*this.ActiveStaff = data.ActiveStaff;
          this.InactiveStaff = data.InactiveStaff;
          this.InactiveStudent = data.InactiveStudent;
          this.ActiveStudent = data.ActiveStudent;*/
          this.Employee = data.InactiveAdminUser;
          this.AdminUser = data.ActiveAdminUser;


        },
        error => {


        }
      );
  }

  getAccountDetails() {
    this.settingservice.fetchAccountDetails()
      .subscribe(
        (data: any) => {

          this.ActiveStudent = data.ActiveStudent;
          this.InactiveStudent = data.InactiveStudent;
          this.ActiveStaff = data.ActiveStaff;
          this.InactiveStaff = data.InactiveStaff;
          this.PercentageActiveStaff = data.PercentageActiveStaff;
          this.PercentageActiveStudent = data.PercentageActiveStudent;
          this.PercentageInactiveStaff = data.PercentageInactiveStaff;
          this.PercentageInactiveStudent = data.PercentageInactiveStudent;


        },
        error => {

        }
      );

  }


  getInactiveStudentList(page: number = 1, searchStudentTerm: string = '') {
   this.isPageLoading = true;
    if ($.fn.DataTable.isDataTable('#deactstudentable')) {
      $('#deactstudenttable').DataTable().destroy();
    }

    this.currentSearchTerm = searchStudentTerm;
    const params = {
      page: page,
      limit: this.pageSizeStudent,
      searchText: searchStudentTerm,
      academicId : this.academicInfo.current_academic,
      sortBy: this.currentSortBy,       
      sortOrder: this.currentSortOrder 
    };
    
    this.settingservice.fetchinactivestudent(params)
      .subscribe(
        (response: any) => {
          this.studentList = response.data || [];
    
          this.currentPage = response.currentPage;
          this.pageSizeStudent = response.pageSize;
          this.totalPages = response.totalPages;
          this.totalRecordsStudent = response.totalRecords;
          this.hasNextPage = response.hasNextPage;
          this.hasPreviousPage = response.hasPreviousPage;
          this.startIndexStudent = response.startIndex;
          this.endIndexStudent = response.endIndex;
          this.searchLengthStudent = response.searchLength;
          this.searchStartStudent = response.searchStartIndex;
          this.searchEndStudent = response.searchEndIndex;

          this.calculatePagesForStudent();

          this.totalPages = Math.ceil(this.totalRecordsStudent / this.pageSizeStudent);
          this.hasPreviousPage = this.currentPage > 1;
          this.hasNextPage = this.currentPage < this.totalPages;

          this.isPageLoading = false;
        },
        error => {
          console.error('Error fetching inactive staff:', error);
          this.studentList = [];
          this.resetPagination();
          this.isPageLoading = false;
        }
      );
  }


  private performStudentSearch(searchStudentTerm: string) {
    this.currentPage = 1;
    this.isStudentSearch = true;
    this.getInactiveStudentList(this.currentPage, searchStudentTerm);
  }
  

  onSearchStudentInput(searchStudentTerm: string) {
    this.isStudentSearch=true;
    this.studentSearch.next(searchStudentTerm);
  }

  onStudentSearch() {
    this.currentPage = 1;
    this.isStudentSearch = true;
    this.getInactiveStudentList(this.currentPage, this.searchStudentTerm);
  }

  clearStudentSearch() {
    this.searchStudentTerm = '';
    this.currentPage = 1;
    this.isStudentSearch = false;
    this.getInactiveStudentList(this.currentPage, '');
  }

goToPageStudent(page: number) {
  if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
    this.currentPage = page;
    this.getInactiveStudentList(page, this.searchStudentTerm);
  }
}

previousPageStudent() {
  if (this.hasPreviousPage) {
    this.currentPage--;
    this.getInactiveStudentList(this.currentPage, this.searchStudentTerm);
  }
}

nextPageStudent() {
  if (this.hasNextPage) {
    this.currentPage++;
    this.getInactiveStudentList(this.currentPage, this.searchStudentTerm);
  }
}


onPageSizeChangeForStudent() {
  this.currentPage = 1;
  this.getInactiveStudentList(this.currentPage, this.searchStudentTerm);
}

   sortStudentTable(column: string) { 

    if (this.currentSortBy === column) {
      this.currentSortOrder = this.currentSortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.currentSortBy = column;
      this.currentSortOrder = 'DESC';
    }
    this.getInactiveStudentList(1, this.currentSearchTerm);
   }


  sortStaffTable(column: string) {
    if (this.currentSortBy === column) {
      this.currentSortOrder = this.currentSortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.currentSortBy = column;
      this.currentSortOrder = 'DESC';
    }
    this.getInactiveStaffList(1, this.currentSearchTerm);
  }

  getInactiveStaffList(page: number = 1, searchTerm: string = '') {
  this.isPageLoading = true;
    if ($.fn.DataTable.isDataTable('#deactstafftable')) {
      $('#deactstafftable').DataTable().destroy();
    }
    this.currentSearchTerm = searchTerm;
    const params = {
      page: page,
      limit: this.pageSize,
      searchText: searchTerm,
      sortBy: this.currentSortBy,       
      sortOrder: this.currentSortOrder 
    };
    
    this.settingservice.fetchinactivestaff(params)
      .subscribe(
        (response: any) => {
          this.staffList = response.data || [];
          
          this.currentPage = response.currentPage;
          this.pageSize = response.pageSize;
          this.totalPages = response.totalPages;
          this.totalRecords = response.totalRecords;
          this.hasNextPage = response.hasNextPage;
          this.hasPreviousPage = response.hasPreviousPage;
          this.startIndex = response.startIndex;
          this.searchLength = response.searchLength;
          this.searchStartIndex = response.searchStartIndex,
          this.searchEndIndex = response.searchEndIndex,
          this.endIndex = response.endIndex;

          this.calculatePages();

          this.isPageLoading = false;

          this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
          this.hasPreviousPage = this.currentPage > 1;
          this.hasNextPage = this.currentPage < this.totalPages;
        },
        error => {
          console.error('Error fetching inactive staff:', error);
          this.staffList = [];
          this.resetPagination();
          this.isPageLoading = false;
        }
      );
  }

  onSearchInput(searchTerm: string) {
    this.isSearch = this.searchTerm && this.searchTerm.trim() !== '';
    this.searchSubject.next(searchTerm);
  }

  private performSearch(searchTerm: string) {
    this.currentPage = 1;
    this.isSearch = this.searchTerm && this.searchTerm.trim() !== '';
    this.getInactiveStaffList(this.currentPage, searchTerm);
  }

  onSearch() {
    this.currentPage = 1;
    this.isSearch = this.searchTerm && this.searchTerm.trim() !== '';
    this.getInactiveStaffList(this.currentPage, this.searchTerm);
  }

  clearSearch() {
    this.searchTerm = '';
    this.currentPage = 1;
    this.isSearch = false;
    this.getInactiveStaffList(this.currentPage, '');
  }

  calculatePages() {
  const pagesSet = new Set<number>(); 
  this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
  
  if (this.totalPages > this.maxVisiblePages) {
    pagesSet.add(1).add(2).add(3);

    if (this.currentPage > 5) {
      pagesSet.add(0); 
    }
    
    const startPage = Math.max(4, this.currentPage - 1);  
    const endPage = Math.min(this.totalPages - 3, this.currentPage + 1);
    
    for (let i = startPage; i <= endPage; i++) {
      pagesSet.add(i); 
    }
    
    if (this.currentPage + 1 < this.totalPages - 3) {
      pagesSet.add(0); 
    }
    
    pagesSet.add(this.totalPages - 2);
    pagesSet.add(this.totalPages - 1);
    pagesSet.add(this.totalPages);
  } else {
    for (let i = 1; i <= this.totalPages; i++) {
      pagesSet.add(i); 
    }
  }
  
  const pages = Array.from(pagesSet);
  this.visiblePages = pages;
}


  calculatePagesForStudent() {
  const pagesSet = new Set<number>(); 
  this.totalPages = Math.ceil(this.totalRecordsStudent / this.pageSizeStudent);
  
  if (this.totalPages > this.maxVisiblePages) {
    pagesSet.add(1).add(2).add(3);

    if (this.currentPage > 5) {
      pagesSet.add(0); 
    }
    
    const startPage = Math.max(4, this.currentPage - 1);  
    const endPage = Math.min(this.totalPages - 3, this.currentPage + 1);
    
    for (let i = startPage; i <= endPage; i++) {
      pagesSet.add(i); 
    }
    
    if (this.currentPage + 1 < this.totalPages - 3) {
      pagesSet.add(0); 
    }
    
    pagesSet.add(this.totalPages - 2);
    pagesSet.add(this.totalPages - 1);
    pagesSet.add(this.totalPages);
  } else {
    for (let i = 1; i <= this.totalPages; i++) {
      pagesSet.add(i); 
    }
  }
  
  const pages = Array.from(pagesSet);
  this.visiblePages = pages;
}

  calculatePagesForFeature() {
    let filtered = this.allFeatures || [];
    if (this.searchFeatureTerm) {
      const term = this.searchFeatureTerm.toLowerCase();
      filtered = filtered.filter(f =>
        (f.BluewingsFeatureDescription && f.BluewingsFeatureDescription.toLowerCase().includes(term))
      );
    }

    // Filter by status
    if (this.selectedStatusFilter && this.selectedStatusFilter !== 'All') {
      filtered = filtered.filter(f => f.ActiveStatus === this.selectedStatusFilter);
    }

    this.filteredFeatures = filtered; 
    this.totalRecordsFeature = filtered.length; 
    this.totalPagesFeature = Math.ceil(this.totalRecordsFeature / this.pageSizeFeature);

    if (this.currentPageFeature > this.totalPagesFeature) {
      this.currentPageFeature = Math.max(1, this.totalPagesFeature);
    }

    const start = (this.currentPageFeature - 1) * Number(this.pageSizeFeature);
    const end = start + Number(this.pageSizeFeature);
    this.paginatedFeatures = filtered.slice(start, end);

    this.startIndexFeature = this.totalRecordsFeature > 0 ? start + 1 : 0;
    this.endIndexFeature = Math.min(start + Number(this.pageSizeFeature), this.totalRecordsFeature);
    this.hasPreviousPageFeature = this.currentPageFeature > 1;
    this.hasNextPageFeature = this.currentPageFeature < this.totalPagesFeature;

    const pagesSet = new Set<number>();
    if (this.totalPagesFeature > this.maxVisiblePages) {
      pagesSet.add(1).add(2).add(3);
      if (this.currentPageFeature > 5) {
        pagesSet.add(0);
      }
      const startPage = Math.max(4, this.currentPageFeature - 1);
      const endPage = Math.min(this.totalPagesFeature - 3, this.currentPageFeature + 1);
      for (let i = startPage; i <= endPage; i++) {
        pagesSet.add(i);
      }
      if (this.currentPageFeature + 1 < this.totalPagesFeature - 3) {
        pagesSet.add(0);
      }
      if (this.totalPagesFeature >= 6) {
        pagesSet.add(this.totalPagesFeature - 2);
        pagesSet.add(this.totalPagesFeature - 1);
        pagesSet.add(this.totalPagesFeature);
      }
    } else {
      for (let i = 1; i <= this.totalPagesFeature; i++) {
        pagesSet.add(i);
      }
    }
    this.visiblePagesFeature = Array.from(pagesSet);
  }

  onSearchFeatureInput(term: string) {
    this.searchFeatureTerm = term;
    this.currentPageFeature = 1;
    this.isFeatureSearch = !!term;
    this.calculatePagesForFeature();
  }

  onStatusFilterChange() {
    this.currentPageFeature = 1;
    this.calculatePagesForFeature();
  }

  onFeatureTableSort(event: any) {
    this.featureSortField = event.field;
    this.featureSortOrder = event.order;
  }

  async initializeStatusFilterOptions() {
    try {
      const allLabel = await firstValueFrom(this.translate.get('all'));
      const enabledLabel = await firstValueFrom(this.translate.get('enabled'));
      const disabledLabel = await firstValueFrom(this.translate.get('disabled'));
      this.statusFilterOptions = [
        { label: allLabel, value: 'All' },
        { label: enabledLabel, value: 'ENABLED' },
        { label: disabledLabel, value: 'DISABLED' }
      ];
    } catch (error) {
      // Fallback to default English labels if translation fails
      this.statusFilterOptions = [
        { label: 'All', value: 'All' },
        { label: 'Enabled', value: 'ENABLED' },
        { label: 'Disabled', value: 'DISABLED' }
      ];
    }
  }

  goToPageFeature(page: number) {
    if (page >= 1 && page <= this.totalPagesFeature && page !== this.currentPageFeature) {
      this.currentPageFeature = page;
      this.calculatePagesForFeature();
    }
  }

  previousPageFeature() {
    if (this.hasPreviousPageFeature) {
      this.currentPageFeature--;
      this.calculatePagesForFeature();
    }
  }

  nextPageFeature() {
    if (this.hasNextPageFeature) {
      this.currentPageFeature++;
      this.calculatePagesForFeature();
    }
  }

  onPageSizeChangeForFeature() {
    this.currentPageFeature = 1;
    this.calculatePagesForFeature();
  }

goToPage(page: number) {
  if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
    this.currentPage = page;
    this.getInactiveStaffList(page, this.searchTerm);
  }
}

previousPage() {
  if (this.hasPreviousPage) {
    this.currentPage--;
    this.getInactiveStaffList(this.currentPage, this.searchTerm);
  }
}

nextPage() {
  if (this.hasNextPage) {
    this.currentPage++;
    this.getInactiveStaffList(this.currentPage, this.searchTerm);
  }
}

firstPage() {
  this.goToPage(1);
}

lastPage() {
  this.goToPage(this.totalPages);
}

onPageSizeChange() {
  this.currentPage = 1;
  this.getInactiveStaffList(this.currentPage, this.searchTerm);
}

getPageNumbers(): number[] {
  return this.visiblePages.filter(page => page !== 0);
}

resetPagination() {
  this.currentPage = 1;
  this.totalPages = 0;
  this.totalRecords = 0;
  this.totalRecordsStudent = 0;
  this.hasNextPage = false;
  this.hasPreviousPage = false;
  this.startIndex = 0;
  this.endIndex = 0;
  this.startIndexStudent = 0;
  this.endIndexStudent = 0;
  this.visiblePages = [];
}



  getDeactivatedStudentList() {
     this.searchStudentTerm = '';
     this.pageSizeStudent = 10;
     this.isStudentSearch = false
    this.getAcademicList(this.getSchoolId)
  }

onDeactivatedStaffTabClick() {
  this.searchTerm = ''; 
  this.pageSize = 10;
  this.isSearch = false;
  this.getDeactivatedStaffList(); 
}

  getDeactivatedStaffList() {
    this.getInactiveStaffList(1, this.searchTerm); 
  }

  getFeatureList() {
    this.bluewingsftrelst = [];

    this.settingservice.fetchFeatureList()
      .subscribe(
        (data: any) => {
          this.isPageLoading = false;
          this.allFeatures = data[0] || [];
          // Sort by name (BluewingsFeatureDescription) by default
          this.allFeatures.sort((a, b) => {
            const nameA = (a.BluewingsFeatureDescription || '').toLowerCase();
            const nameB = (b.BluewingsFeatureDescription || '').toLowerCase();
            return nameA.localeCompare(nameB);
          });
          this.calculatePagesForFeature();
        },

        error => {
          this.isPageLoading = false;
        }
      );
  }

  updateFeatureList(flist, status, index) {
    flist.loading = true;

    this.settingservice.fetchUpdateFeatureList(flist.pkSchoolFeatureId, status)
      .subscribe(
        async (data: any) => {
          flist.loading = false;
          if (data.status) {
            flist.ActiveStatus = status;
            const featureSuccessfullyUpdatedPleaseLogoutAndLoginToAffectChangesTranslation = await firstValueFrom(this.translate.get('featureSuccessfullyUpdatedPleaseLogoutAndLoginToAffectChanges'));
            customToastr(featureSuccessfullyUpdatedPleaseLogoutAndLoginToAffectChangesTranslation, 'success');
          }
          else {
            flist.ActiveStatus = status == 'ENABLED' ? 'DISABLED' : 'ENABLED';
            const failedToUpdateFeaturePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToUpdateFeaturePleaseTryAgain'));
            customToastr(failedToUpdateFeaturePleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          flist.loading = false;
          flist.ActiveStatus = status == 'ENABLED' ? 'DISABLED' : 'ENABLED';
          const failedToUpdateFeaturePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToUpdateFeaturePleaseTryAgain'));
          customToastr(failedToUpdateFeaturePleaseTryAgainTranslation, 'error');
        }
      );
  }

  destroyDataTable(table) {
    $('#' + table).DataTable().destroy();
  }
  initializeDataTable(table) {
    setTimeout(() => {
      this.translate.get([
        'dataTables.emptyTable',
        'dataTables.search',
        'dataTables.lengthMenu',
        'dataTables.info',
        'dataTables.infoEmpty',
        'dataTables.paginate.next',
        'dataTables.paginate.previous',
      ]).subscribe(translations => {
        $('#' + table).DataTable({
          "order": [[0, 'asc']],
          destroy: true ,
          language: {
            emptyTable: translations['dataTables.emptyTable'],
            search: translations['dataTables.search'],
            lengthMenu: translations['dataTables.lengthMenu'],
            info: translations['dataTables.info'],
            infoEmpty: translations['dataTables.infoEmpty'],
            paginate: {
              next: translations['dataTables.paginate.next'],
              previous: translations['dataTables.paginate.previous']
            }
          },
        });
      });
      //this.scriptInit();
    }, 500);
  }
  initializeDataTableOrder(table) {
    setTimeout(() => {
      this.translate.get([
        'dataTables.emptyTable',
        'dataTables.search',
        'dataTables.lengthMenu',
        'dataTables.info',
        'dataTables.infoEmpty',
        'dataTables.paginate.next',
        'dataTables.paginate.previous',
      ]).subscribe(translations => {
        $('#' + table).DataTable({
          "order": [],
          destroy: true,
          language: {
            emptyTable: translations['dataTables.emptyTable'],
            search: translations['dataTables.search'],
            lengthMenu: translations['dataTables.lengthMenu'],
            info: translations['dataTables.info'],
            infoEmpty: translations['dataTables.infoEmpty'],
            paginate: {
              next: translations['dataTables.paginate.next'],
              previous: translations['dataTables.paginate.previous']
            }
          },
        });
      });
      //this.scriptInit();
    }, 500);
  }

  getUserList() {
    this.destroyDataTable('userAdmin-table');
    this.userlst = [];
    this.settingservice.fetchUpdateUserList()
      .subscribe(
        (data: any) => {
          var uList = data[0];
          for (var i = 0; i < uList.length; i++) {
            this.userlst.push(uList[i]);
            if (uList.length - 1 == i) {
              this.initializeDataTable('userAdmin-table');
            }
          }

        },

        error => {

        }
      );
  }

  searchUserList() {
    var a = $('#groupbutton10').val();
    this.settingservice.fetchSearchUserList(a)
      .subscribe(
        (data: any) => {

          this.userlst = data[0];

        },

        error => {

        }
      );
  }

  getCurrentSchoolDetails() {

    this.settingservice.fetchSchoolDetails()
      .subscribe(
        (data: any) => {


          this.updateschool = data;
        },

        error => {

        }
      );
  }

 
  async getTimeZoneList() {
    try {
      this.getTimeZoneArray = [];
       const data = await firstValueFrom(
        this.settingservice.fetchTimeZoneList(this.getAuthToken)
        .pipe(
          map((response: any) =>
            response.body.map((timezone: any) => ({
              pkSupportedTimeZoneId: timezone.pkSupportedTimeZoneId,
              region: timezone.region,
              isSelected: timezone.isSelected
            }))
          )
        )
      );
      this.getTimeZoneArray = data;
      this.selectedTimezone = this.getTimeZoneArray.find(timeZone => timeZone.isSelected == 1);
    if (this.selectedTimezone) {
      this.selectedTimezone = this.selectedTimezone.pkSupportedTimeZoneId; 
    } else {
      this.selectedRegion = "Select Timezone"; 
    }
    } catch (error) {
      console.error('Error fetching time zone list:', error);
    }
  }

  async getSelectedTimeZone(selectedTimeZone) {
    this.selectedTimeZoneId = selectedTimeZone;
  }

  async setSchoolTimeZone() {    
    try {
      const body = {
        timeZone: this.selectedTimeZoneId,
        lang: "en"
      };
    const response = await firstValueFrom(this.settingservice.setTimeZone(body, this.getAuthToken));
    const responseDetails = response as any;
    if (responseDetails && responseDetails.status == true) {
      const timezoneUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('timezoneUpdatedSuccessfully')); 
      customToastr(timezoneUpdatedSuccessfullyTranslation, 'success');
      $('.backdrop').trigger('click');
    } else {
      const timezoneNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('timezoneNotUpdatedPleaseTryAgain')); 
      customToastr(timezoneNotUpdatedPleaseTryAgainTranslation, 'error');
    }
    } catch(error) {
      console.error("Error while storing the timezone value :", error);
    }
  }


  staffChat(status) {
    this.staffChatStatusInput = status;


  }


  stuChat(status) {

    this.parentChatStatusInput = status;

  }
  openbrowsertoupldphstaff() {
    $("#openfile").trigger('click');

  }

  async updateLatestSchoolDetails() {

    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#updatebtndisable').text(translatedText); });
    $("#updatebtndisable").attr('disabled', true);
    if (this.validateRequiredField(this.updateschool.schoolName)
      && this.validateRequiredField(this.updateschool.phoneNumber)
      && this.validateRequiredField(this.updateschool.emailId)
      && this.validateRequiredField(this.updateschool.address)
      && this.validateRequiredField(this.updateschool.locality)
      && this.validateRequiredField(this.updateschool.state)
      && this.validateRequiredField(this.updateschool.pincode)
      && this.validateRequiredField(this.updateschool.description)) {

      if (this.staffChatStatusInput == true) {
        let staffChatMessageLimitValue = $('#numchatlimitst').val();
        if (!staffChatMessageLimitValue) {
          staffChatMessageLimitValue = 0;
        } else {
          staffChatMessageLimitValue = parseInt(staffChatMessageLimitValue);
        }
        if (staffChatMessageLimitValue < 10) {
          this.translate.get('updateChanges').subscribe((translatedText: string) => { $('#updatebtndisable').text(translatedText); });
          $("#updatebtndisable").attr('disabled', false);
          const minimumChatMessageLimitForStaffAndParentShouldBe10Translation = await firstValueFrom(this.translate.get('minimumChatMessageLimitForStaffAndParentShouldBe10')); 
          customToastr(minimumChatMessageLimitForStaffAndParentShouldBe10Translation, 'error');
          return ;
        }
        this.updateschool.staffChatMessageLimit = staffChatMessageLimitValue;
      } else {
        this.updateschool.staffChatMessageLimit = "UNLIMITED";
      }
      if (this.parentChatStatusInput == true) {
        let parentChatMessageLimitValue = $('#numchatlimit').val();
        if (!parentChatMessageLimitValue) {
          parentChatMessageLimitValue = 0;
        } else {
          parentChatMessageLimitValue = parseInt(parentChatMessageLimitValue)
        }
        if (parentChatMessageLimitValue < 10) {
          this.translate.get('updateChanges').subscribe((translatedText: string) => { $('#updatebtndisable').text(translatedText); });
          $("#updatebtndisable").attr('disabled', false);
          const minimumChatMessageLimitForStaffAndParentShouldBe10Translation = await firstValueFrom(this.translate.get('minimumChatMessageLimitForStaffAndParentShouldBe10')); 
          customToastr(minimumChatMessageLimitForStaffAndParentShouldBe10Translation, 'error');
          return ;
        }
        this.updateschool.parentChatMessageLimit = parentChatMessageLimitValue;
      } else {
        this.updateschool.parentChatMessageLimit = "UNLIMITED";
      }

      if ($('#phonenum').val().length == 10) {
        this.settingservice.updateSchoolDetails(this.updateschool.schoolName, this.updateschool.phoneNumber, this.updateschool.emailId, this.updateschool.address, this.updateschool.locality, this.updateschool.state, this.updateschool.pincode, this.updateschool.description, this.updateschool.parentChatMessageLimit, this.updateschool.staffChatMessageLimit)
          .subscribe(
            async (data: any) => {

              if (data.status == true) {
                this.translate.get('updateChanges').subscribe((translatedText: string) => { $('#updatebtndisable').text(translatedText); });
                $("#updatebtndisable").attr('disabled', false);

               const schoolDetailsUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('schoolDetailsUpdatedSuccessfully')); 
               customToastr(schoolDetailsUpdatedSuccessfullyTranslation, 'success');
                $(".backdrop").trigger("click");
                this.getSchoolDetails();

              } else {
                const schoolDetailsNotUpdatedSuccessfullyPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('schoolDetailsNotUpdatedSuccessfullyPleaseTryAgain')); 
                customToastr(schoolDetailsNotUpdatedSuccessfullyPleaseTryAgainTranslation, 'error');
              }
            },

            error => {

            }
          );
      }

      else {
        this.translate.get('updateChanges').subscribe((translatedText: string) => { $('#updatebtndisable').text(translatedText); });
        $("#updatebtndisable").attr('disabled', false);
        const mobileNumberShouldBe10DigitsOnlyTranslation = await firstValueFrom(this.translate.get('mobileNumberShouldBe10DigitsOnly')); 
        customToastr(mobileNumberShouldBe10DigitsOnlyTranslation, 'error');
      }
    }
    else {
      this.translate.get('updateChanges').subscribe((translatedText: string) => { $('#updatebtndisable').text(translatedText); });
      $("#updatebtndisable").attr('disabled', false);
      const pleaseFillAllTheFieldsTranslation = await firstValueFrom(this.translate.get('pleaseFillAllTheFields')); 
      customToastr(pleaseFillAllTheFieldsTranslation, 'error');
    }
  }


  showHide(event) {

    if (event == "SUPER_ADMIN") {
      this.featurelist = false;


    } else if (event == "SUB_ADMIN") {
      this.featurelist = true;
      this.adminUserPopUpExistingDetails(this.getuserdetails, false);

    }
  }

  showHideAddUser(eventadduser) {


    if (eventadduser == "SUPER_ADMIN") {
      this.featurelist = false;
    } else if (eventadduser == "SUB_ADMIN") {
      this.featurelist = true;

    }

  }

  async addUserDetails() {


    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#adduserbuttondsble').text(translatedText); });
    $("#adduserbuttondsble").attr('disabled', true);

    var flist = [];
    if (this.adduser.AccessType == "SUB_ADMIN") {
      this.getuserfeaturelist.forEach(function (feature) {

        if (feature.select == true) {
          flist.push({ pkSchoolFeatureId: feature.pkSchoolFeatureId, AdminAccessStatus: "ENABLED" })
        } else {
          flist.push({ pkSchoolFeatureId: feature.pkSchoolFeatureId, AdminAccessStatus: "DISABLED" })
        }

      });

    }

    if (this.adduser.emailId != null && this.adduser.emailId != "" && this.adduser.emailId != undefined && this.adduser.username != null && this.adduser.username != "" && this.adduser.username != undefined && this.adduser.password != null && this.adduser.password != "" && this.adduser.password != undefined && this.adduser.cnfmpassword != null && this.adduser.cnfmpassword != "" && this.adduser.cnfmpassword != undefined && this.adduser.PhoneNumber != null && this.adduser.PhoneNumber != "" && this.adduser.PhoneNumber != undefined) {
      if ($('#adduserphnum').val().length == 10) {
        if (this.adduser.password != this.adduser.cnfmpassword) {
          this.translate.get('ADD_USER').subscribe((translatedText: string) => { $('#adduserbuttondsble').text(translatedText); });
          $("#adduserbuttondsble").attr('disabled', false);
          const passwordDoNotMatchTranslation = await firstValueFrom(this.translate.get('passwordDoNotMatch')); 
          customToastr(passwordDoNotMatchTranslation, 'error');
        }
        else {
          this.settingservice.addAdminUserDetails(this.adduser.emailId, this.adduser.username, this.adduser.password, this.adduser.cnfmpassword, this.adduser.PhoneNumber,
            this.adduser.AccessType, flist)
            .subscribe(
              async (data: any) => {

                if (data.status == true) {
                  const newUserAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('newUserAddedSuccessfully')); 
                  customToastr(newUserAddedSuccessfullyTranslation, 'success');
                  $("#adduser").trigger("click");
                  this.getUserList();
                }
                else if (data.message == "EXIST") {

                  this.translate.get('ADD_USER').subscribe((translatedText: string) => { $('#adduserbuttondsble').text(translatedText); });
                  $("#adduserbuttondsble").attr('disabled', false);

                  const userAlreadyExistTranslation = await firstValueFrom(this.translate.get('userAlreadyExist')); 
                  customToastr(userAlreadyExistTranslation, 'error');

                }
                else {
                  const userIsNotAddedSuccessfullyPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('userIsNotAddedSuccessfullyPleaseTryAgain')); 
                  customToastr(userIsNotAddedSuccessfullyPleaseTryAgainTranslation, 'error');
                }
              },

              error => {

              }
            );
        }
      }
      else {
        this.translate.get('ADD_USER').subscribe((translatedText: string) => { $('#adduserbuttondsble').text(translatedText); });
        $("#adduserbuttondsble").attr('disabled', false);
        const mobileNumberShouldBe10DigitsOnlyTranslation = await firstValueFrom(this.translate.get('mobileNumberShouldBe10DigitsOnly')); 
        customToastr(mobileNumberShouldBe10DigitsOnlyTranslation, 'error');

      }
    }
    else {
      this.translate.get('ADD_USER').subscribe((translatedText: string) => { $('#adduserbuttondsble').text(translatedText); });
      $("#adduserbuttondsble").attr('disabled', false);
      const pleaseProvideAllDetailsToAddAdminTranslation = await firstValueFrom(this.translate.get('pleaseProvideAllDetailsToAddAdmin')); 
      customToastr(pleaseProvideAllDetailsToAddAdminTranslation, 'error');
    }
  }

  editUserPopup() {
    $('#editUserModal').modal('show');
  }

  adminUserPopUpExistingDetails(uyt, isFirstTime) {

    this.getuserdetails = uyt;
    if (isFirstTime) {
      if (uyt.AccessType == "SUPER_ADMIN")
        this.featurelist = false;
      else if (uyt.AccessType == "SUB_ADMIN") {
        this.featurelist = true;
      }
    }

    this.translate.get('UPDATE_USER').subscribe((translatedText: string) => { $('#edituser').text(translatedText); });
    $('#edituser').attr('disabled', false);
    this.getuserdetails = JSON.parse(JSON.stringify(uyt));

    this.selecteduserId = uyt.pkSchoolAdminsId;


    this.settingservice.getAdminUserFeatureDetails(uyt.pkSchoolAdminsId)
      .subscribe(
        (data: any) => {

          this.getuserfeaturelist = data;
          $("#edituserFeatures").html("");
          for (var i = 0; i < data.length; i++) {
            if (this.getuserfeaturelist[i].AdminAccessStatus == "ENABLED") {
              var h = $('<label class="checkbox-inline checkbox-styled checkbox-primary col-md-12" style="margin: 0px;">' +
                '<input type="checkbox" class="featureBox" id="updatefeature" value="option1" name="featured" ><span></span>' +
                '</label>');
              h.find("span").text(this.getuserfeaturelist[i].BluewingsFeatureDescription);
              h.find('input').attr("checked", true);
              h.find('input').attr("fId", this.getuserfeaturelist[i].pkSchoolFeatureId);
              h.find('input').attr("id", "update_per_" + i);
              h.find('input').attr("name", "n_per_" + i);
              $("#edituserFeatures").append(h);
            } else {
              var h = $('<label class="checkbox-inline checkbox-styled checkbox-primary col-md-12" style="margin: 0px;">' +
                '<input type="checkbox" class="featureBox" id="updatefeature" value="option1" name="featured" ><span></span>' +
                '</label>');
              h.find("span").text(this.getuserfeaturelist[i].BluewingsFeatureDescription);
              h.find('input').attr("checked", false);
              h.find('input').attr("fId", this.getuserfeaturelist[i].pkSchoolFeatureId);
              h.find('input').attr("id", "update_per_" + i);
              h.find('input').attr("name", "n_per_" + i);
              $("#edituserFeatures").append(h);


            }
          }
        },

        error => {

        }
      );
  }

  selectedUserIdToChangePswd(u) {

    this.translate.get('updatePassword').subscribe((translatedText: string) => { $('#changepswd').text(translatedText); });
    $("#changepswd").attr('disabled', false);

    this.userPassword = "";
    this.usercnfmpassword = "";
    this.selecteduserIdForPswd = u.pkSchoolAdminsId;
  }
  async updatePasswordForUser() {

    if (this.validateRequiredField(this.userPassword)
      && this.validateRequiredField(this.usercnfmpassword)) {
      if (this.userPassword != this.usercnfmpassword) {
        this.translate.get('updatePassword').subscribe((translatedText: string) => { $('#changepswd').text(translatedText); });
        $("#changepswd").attr('disabled', false);
        const confirmPasswordNotMatchingTranslation = await firstValueFrom(this.translate.get('confirmPasswordNotMatching')); 
        customToastr(confirmPasswordNotMatchingTranslation, 'error');
      }
      else {
        this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#changepswd').text(translatedText); });
        $("#changepswd").attr('disabled', true);
        this.settingservice.updateUserPassword(this.userPassword, this.selecteduserIdForPswd)
          .subscribe(
            async (data: any) => {
              if (data.status == true) {
                const adminUserPasswordUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('adminUserPasswordUpdatedSuccessfully')); 
                customToastr(adminUserPasswordUpdatedSuccessfullyTranslation, 'success');
                $("#passwordpopupclose").trigger("click");
              }
              else {
                const adminUserPasswordNotUpdatedTranslation = await firstValueFrom(this.translate.get('adminUserPasswordNotUpdated')); 
                customToastr(adminUserPasswordNotUpdatedTranslation, 'error');
                this.translate.get('updatePassword').subscribe((translatedText: string) => { $('#changepswd').text(translatedText); });
                $("#changepswd").attr('disabled', false);
              }

            },
            error => {

            });
      }
    }
    else {
      this.translate.get('updatePassword').subscribe((translatedText: string) => { $('#changepswd').text(translatedText); });
      $("#changepswd").attr('disabled', false);
      const pleaseProvidePasswordTranslation = await firstValueFrom(this.translate.get('pleaseProvidePassword')); 
      customToastr(pleaseProvidePasswordTranslation, 'error');
    }
  }





  async updateAdminUser() {


    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#edituser').text(translatedText); });
    $("#edituser").attr('disabled', true);


    var fuserlst = [];

    $("#edituserFeatures").find(".featureBox").map(function (i, ele) {
      var f = $(ele);
      var id = f.attr("fId");
      var status = f.prop('checked');
      if (status) {
        fuserlst.push({ pkSchoolFeatureId: id, AdminAccessStatus: "ENABLED" })
      } else {
        fuserlst.push({ pkSchoolFeatureId: id, AdminAccessStatus: "DISABLED" })
      }
    });

    if (this.validateRequiredField(this.getuserdetails.emailId)
      && this.validateRequiredField(this.getuserdetails.adminPhoneNumber)) {
      if ($('#mobnum').val().length == 10) {
        this.settingservice.updateAdminUserDetails(this.getuserdetails.emailId, this.getuserdetails.adminPhoneNumber, this.getuserdetails.AccessType, this.getuserdetails.AdminAccessStatus, fuserlst, this.getuserdetails.pkSchoolAdminsId)
          .subscribe(
            async (data: any) => {
              if (data.status == true) {
                const userUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('userUpdatedSuccessfully')); 
                customToastr(userUpdatedSuccessfullyTranslation, 'success');
                $("#edituserpopupclose").trigger("click");
                this.getUserList();
              }
              else {
                this.translate.get('UPDATE_USER').subscribe((translatedText: string) => { $('#edituser').text(translatedText); });
                $("#edituser").attr('disabled', false);
                const userIsNotUpdatedSuccessfullyPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('userIsNotUpdatedSuccessfullyPleaseTryAgain')); 
                customToastr(userIsNotUpdatedSuccessfullyPleaseTryAgainTranslation, 'error');
              }
            },

            error => {

            }
          );
      } else {
        this.translate.get('UPDATE_USER').subscribe((translatedText: string) => { $('#edituser').text(translatedText); });
        $("#edituser").attr('disabled', false);
        const mobileNumberShouldBe10DigitsOnlyTranslation = await firstValueFrom(this.translate.get('mobileNumberShouldBe10DigitsOnly')); 
        customToastr(mobileNumberShouldBe10DigitsOnlyTranslation, 'error');

      }
    }
    else {
      this.translate.get('UPDATE_USER').subscribe((translatedText: string) => { $('#edituser').text(translatedText); });
      $("#edituser").attr('disabled', false);
      const pleaseFillAllTheFieldsTranslation = await firstValueFrom(this.translate.get('pleaseFillAllTheFields')); 
      customToastr(pleaseFillAllTheFieldsTranslation, 'error');
    }
  }
  deleteAdminUser() {
    this.settingservice.deleteAdminUserDetails(this.selecteduserId)
      .subscribe(
        async (data: any) => {
          if (data.status == true) {
            const adminUserDeletedTranslation = await firstValueFrom(this.translate.get('adminUserDeleted')); 
            customToastr(adminUserDeletedTranslation, 'success');
            $("#deletepopupclose").trigger("click");
            this.getUserList();
          }
          else {
            const adminUserInNotDeletedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('adminUserInNotDeletedPleaseTryAgain'));
             customToastr(adminUserInNotDeletedPleaseTryAgainTranslation, 'error');
          }
        },
        error => {
        });
  }

  deleteuserid(u) {
    this.selecteduserId = u.pkSchoolAdminsId;

  }
  activateUser(user) {
    this.adminId = user.pkSchoolAdminsId;
  }
  activateAdminUser() {
    this.settingservice.activateAdmin(this.adminId)
      .subscribe(
        async (data: any) => {
          if (data.status == true) {
           const adminUserActivatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('adminUserActivatedSuccessfully')); 
           customToastr(adminUserActivatedSuccessfullyTranslation, 'success');
            $("#activeAdminColse").trigger("click");
            this.getUserList();
          }
          else {
            const adminUserInNotActivatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('adminUserInNotActivatedPleaseTryAgain')); 
            customToastr(adminUserInNotActivatedPleaseTryAgainTranslation, 'error');
          }
        },
        error => {
        });
  }

  openPopUp() {


    this.translate.get('ADD_USER').subscribe((translatedText: string) => { $('#adduserbuttondsble').text(translatedText); });
    $("#adduserbuttondsble").attr('disabled', false);


    this.adduser = { emailId: "", username: "", password: "", cnfmpassword: "", PhoneNumber: "", AccessType: "SUB_ADMIN" };

    this.settingservice.getAdminUserFeatureList()
      .subscribe(
        (data: any) => {

          this.getuserfeaturelist = data;

        },

        error => {

        }
      );

  }

  reactivateStudentDetails(st, type) {
    st.accountType = type;
    this.reactivatestudetails = st;

  }
  editInfoOffcanvas() {
    $("#hideforschool").removeClass('hide');
    //this.getCurrentSchoolDetails();
    this.offcanvas.handleOffcanvasOpen("#offcanvas-editInfo");
  }
  reactivatestudent() {

    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#reactive').text(translatedText); });
    $("#reactive").attr('disabled', true);
    if (this.reactivatestudetails.accountType == "STUDENT") {

      this.settingservice.reactivateStudent(this.reactivatestudetails.studentId)
        .subscribe(
          async (data: any) => {
            this.translate.get('REACTIVATE').subscribe((translatedText: string) => { $('#reactive').text(translatedText); });
            $("#reactive").attr('disabled', false);
            if (data.status == true) {
              const studentReactivatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentReactivatedSuccessfully')); 
              customToastr(studentReactivatedSuccessfullyTranslation, 'success');
              $(".reactivatepopupclose").trigger("click");
              this.getInactiveStudentList();

            } else {
              const studentNotReactivatedSuccessfullyPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('studentNotReactivatedSuccessfullyPleaseTryAgain')); 
              customToastr(studentNotReactivatedSuccessfullyPleaseTryAgainTranslation, 'error');
            }
          },

          error => {
            this.translate.get('REACTIVATE').subscribe((translatedText: string) => { $('#reactive').text(translatedText); });
            $("#reactive").attr('disabled', false);
          }
        );


    } else {
      this.settingservice.reactivatestaff(this.reactivatestudetails.studentId)

        .subscribe(
          async (data: any) => {
            this.translate.get('REACTIVATE').subscribe((translatedText: string) => { $('#reactive').text(translatedText); });
            $("#reactive").attr('disabled', false);
            if (data.status == true) {
              const staffReactivatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('staffReactivatedSuccessfully')); 
              customToastr(staffReactivatedSuccessfullyTranslation, 'success');
              $(".reactivatepopupclose").trigger("click");
              this.getInactiveStaffList();

            } else {
              const failedToReactivateStaffPleaseContactAdminTranslation = await firstValueFrom(this.translate.get('failedToReactivateStaffPleaseContactAdmin')); 
              customToastr(failedToReactivateStaffPleaseContactAdminTranslation, 'error');
            }

          },
          error => {
            this.translate.get('REACTIVATE').subscribe((translatedText: string) => { $('#reactive').text(translatedText); });
            $("#reactive").attr('disabled', false);
          }
        );
    }


  }

  reactivateStaffDetails(staff, type) {

    this.reactivatestudetails = {
      accountType: type,
      parentName: staff.staffName,
      mobileNumber: staff.mobileNumber,
      emailId: staff.emailId,
      reason: staff.reason,
      studentId: staff.staffId
    };

  }
  uploadSchoolImage(authToken, imageName, schoolId) {

    var h = this;

    var imageUploadTappedForSchool = false;
    var ImageUploadDataForSchool = new FormData();
    ImageUploadDataForSchool.append('image', $("#" + imageName)[0].files[0]);

    $.ajax({
      beforeSend: function (request) {

        request.setRequestHeader("enctype", 'multipart/form-data');
        request.setRequestHeader("authToken", authToken);
      },
      url: AppSettings.API_ENDPOINT + '/upload/image?userType=SCHOOL&userId=' + schoolId,
      data: ImageUploadDataForSchool,
      cache: false,
      processData: false,
      contentType: false,
      xhr: function () {
        //upload Progress
        var xhr = $.ajaxSettings.xhr();
        if (xhr.upload) {
          xhr.upload.addEventListener('progress', function (event) {
            var percent = 0;
            var position = event.loaded || event.position;
            var total = event.total;
            if (event.lengthComputable) {
              percent = Math.ceil(position / total * 100);
            }
            $("#schooledit-progressbar").removeClass("hide");

            this.translate.get('uploading').subscribe((translatedText: string) => { $("#schooledit-progressbar").text(translatedText+ percent + '%'); });

          }, true);
        }
        return xhr;
      },
      type: 'POST',
       success: async function (data, status, req) {
        imageUploadTappedForSchool = true;
        //$("#change_photo_text").text("Change Photo");
        if (data && data.status) {
          // show success message
          /* this.uploadSchoolImage(localStorage.getItem('usertoken'),"openfile",data.schoolId);*/
          //$("#progressbar").removeClass("hide");
          h.getSchoolDetails();
          $("#hideforschool").removeClass('hide');
          $("#schooledit-progressbar").addClass('hide');
          const profileImageUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('profileImageUpdatedSuccessfully')); 
          customToastr(profileImageUpdatedSuccessfullyTranslation, 'success');
          //this.addNewStaffDataClear();
          //$('#closeAddStaff').trigger("click");
        }
        else {
          // show error message
          $("#hideforschool").removeClass('hide');
          $("#schooledit-progressbar").addClass('hide');
          const profileImageNotUpdatedTranslation = await firstValueFrom(this.translate.get('profileImageNotUpdated')); 
          customToastr(profileImageNotUpdatedTranslation, 'error');
        }
        this.profileImageSelectedForStaff = false;
      },
      error: async function (req, status, error) {
        this.translate.get('changePhoto').subscribe((translatedText: string) => { $('#change_photo_text').text(translatedText); });
        imageUploadTappedForSchool = true;
        // show error message
        $("#hideforschool").removeClass('hide');
        $("#schooledit-progressbar").addClass('hide');
       const profileImageNotUpdatedServerNotReachableTranslation = await firstValueFrom(this.translate.get('profileImageNotUpdatedServerNotReachable')); 
       customToastr(profileImageNotUpdatedServerNotReachableTranslation, 'error');
        this.profileImageSelectedForStaff = false;
      }
    });

  }



  ngOnInit() {
    this.searchStudentTerm = '';
    this.searchTerm = '';
    this.loginMode = localStorage.getItem('loginMode');
    this.scriptLoader.loadScript($, "DASHBOARD")
    if (this.loginMode == "STAFF") {
      this.router.navigate(['/exams']);
    }
    var h = this;
    var profileImageSelectedforsSchoolImage = false;

    var adminPermissionlist = localStorage.getItem('adminPermissionlist');
    if (adminPermissionlist) {
      this.academicPermissions = JSON.parse(adminPermissionlist);
    }

    this.getSchoolDetails();
    this.getOverViewDetails();
    this.getAccountDetails();
    this.getFeatureList();
    //this.getUserList();
    this.getCurrentSchoolDetails();
    this.getTimeZoneList();
    this.getSchoolSettingsList();
    this.initializeStatusFilterOptions();
   


    $('#openfile').change(async function () {

      $("#hideforschool").addClass('hide');
      $("#schooledit-progressbar").removeClass('hide');



      var extension = $(this).val().split('.').pop().toLowerCase();
      var ExtListToUpload = new Array('gif', 'jpeg', 'png', 'jpg');
      var isValidFileExt = $.inArray(extension, ExtListToUpload);
      if (isValidFileExt == -1) {

        profileImageSelectedforsSchoolImage = false;
        $(this).replaceWith($(this).val('').clone(true));
        $("#hideforschool").removeClass('hide');
        $("#schooledit-progressbar").addClass('hide');
       const pleaseSelectAValidImageTypeOfGifJpegPngJpgTranslation = await firstValueFrom(this.translate.get('pleaseSelectAValidImageTypeOfGifJpegPngJpg')); 
       customToastr(pleaseSelectAValidImageTypeOfGifJpegPngJpgTranslation, 'error');
      } else {

        profileImageSelectedforsSchoolImage = false;
        if ($(this).get(0).files[0].size > (1024 * 1024 * 20)) {

          $(this).replaceWith($(this).val('').clone(true));
          $("#hideforschool").removeClass('hide');
          $("#schooledit-progressbar").addClass('hide');
          const imageSizeShouldNotExceed20MbTranslation = await firstValueFrom(this.translate.get('imageSizeShouldNotExceed20Mb')); 
          customToastr(imageSizeShouldNotExceed20MbTranslation, 'error');
        } else {

          profileImageSelectedforsSchoolImage = true;
          if (this.files && this.files[0]) {
            var reader = new FileReader();
            reader.onload = imageIsLoadedForSchool;
            reader.readAsDataURL(this.files[0]);
          }
          h.uploadSchoolImage(localStorage.getItem('usertoken'), "openfile", '')

        }
      }
    });
    function imageIsLoadedForSchool(e) {
      $('#schoolimageupload').attr('src', e.target.result);
    };
    this.langChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
       
      this.getInactiveStudentList();
      this.getInactiveStaffList();
      this.getUserList();
      this.initializeStatusFilterOptions();
      this.getFeatureList();
      this.getExamBoard();

    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  validateRequiredField(data) {
    if (data == null || data == "" || data == undefined) {
      return false;
    } else {
      return true;
    }
  }

  updateGenerateStudentRegistrationId(value) {
    //customToastr("Update to "+(value ? 'AUTO' : 'MANUAL'),'success');
    this.isProcessing = true;
    this.settingservice.updateGenerateRegIdSetting(value ? 'AUTO' : 'MANUAL')
      .subscribe(
        async (data: any) => {
          this.isProcessing = false;
          if (data.status) {
            const settingType = value
              ? await firstValueFrom(this.translate.get('autoGenerate'))
              : await firstValueFrom(this.translate.get('manualProvide'));

            const message = await firstValueFrom(
              this.translate.get('registrationSettingUpdated', { value: settingType })
            );

            customToastr(message, 'success');
          }
          else {
            const failedToUpdateSettingTranslation = await firstValueFrom(this.translate.get('failedToUpdateSetting')); 
            customToastr(failedToUpdateSettingTranslation, 'error');
            this.GenerateStudentRegistrationId = !this.GenerateStudentRegistrationId;
          }
        },
        async error => {
          this.isProcessing = false;
          const failedToUpdateSettingTranslation = await firstValueFrom(this.translate.get('failedToUpdateSetting')); 
          customToastr(failedToUpdateSettingTranslation, 'error');
          this.GenerateStudentRegistrationId = !this.GenerateStudentRegistrationId;
        }
      );
  }

  /*MANAGE BOARD START HERE*/

  configGrade = [{ minMarks: "", maxMarks: "", grade: "", gradePoint: "" }];
  createPattern = {
    patternName: "", patternDesc: "", totalMarks: "", totalSection: null,
    sections: []
  };
  async addRowInConfigResult(data) {
    let gradeData = data;
    this.createPattern.sections = [];
    if (parseInt(gradeData.minMarks) >= parseInt(gradeData.maxMarks)) {
      const maximumMarksShouldBeGreaterThanMinimumMarksTranslation = await firstValueFrom(this.translate.get('maximumMarksShouldBeGreaterThanMinimumMarks')); 
      customToastr(maximumMarksShouldBeGreaterThanMinimumMarksTranslation, 'error');
      return;
    }
    let arrayLength = (this.configGrade.length - 2);
    /*let minValue = parseInt(this.configGrade[arrayLength].minMarks);
    let maxValue = parseInt(this.configGrade[arrayLength].maxMarks);*/
    if (arrayLength >= 0) {
      let minGradeVal = parseInt(this.configGrade[arrayLength].maxMarks) + 1;
      let maxGradeVal = parseInt(this.configGrade[arrayLength].minMarks) - 1;
      if ((parseInt(gradeData.minMarks) == minGradeVal) || parseInt(gradeData.maxMarks) == maxGradeVal) {
        this.configGrade.push({
          minMarks: "", maxMarks: "", grade: "", gradePoint: ""
        });
      }
      else {
        const wrongDataEntryPleaseCheckCarefullyTranslation = await firstValueFrom(this.translate.get('wrongDataEntryPleaseCheckCarefully')); 
        customToastr(wrongDataEntryPleaseCheckCarefullyTranslation, 'error');
        return;
      }
    }
    else {
      this.configGrade.push({
        minMarks: "", maxMarks: "", grade: "", gradePoint: ""
      });
    }
  }
  removeRowConfigResult() {
    for (var i = 0; i < 1; i++) {
      this.configGrade.splice(this.configGrade.indexOf({
        minMarks: "", maxMarks: "", grade: "", gradePoint: ""
      }), 1);
    }
  }
  boardName: "";
  evalType = "0";
  gradeConfigButton = false;
  applyGradingSystem = false;
  changeEvalType(getEvalType) {
    if (getEvalType == "GRADES" || getEvalType == "MARKS_GRADES") {
      this.applyGradingSystem = true;
      this.gradeConfigButton = true;
    }
    else {
      this.applyGradingSystem = false;
      this.gradeConfigButton = false;
    }
  }
  selectAllClass() {
    var isSel = $("#selectAllClass").prop("checked");
    /*this.classAndSectionList.forEach(function (st) {
      st.select=isSel;
    });*/
    for (var i = 0; i < this.classAndSectionList.length; i++) {
      for (var j = 0; j < this.classAndSectionList[i].section.length; j++) {
        this.classAndSectionList[i].section[j].select = isSel;
        this.classAndSectionList[i].select = isSel;
      }
    }
  }
  allSection = false;
  selectAllSection() {
    var isSel = $("#selectAllSection").prop("checked");
    this.sectionListOfClass.forEach(function (st) {
      st.select = isSel;
    });
  }
  checkingSelectSection(classDetails) {
    var selectList = [];
    var selectClassList = [];
    for (var i = 0; i < classDetails.length; i++) {
      if (classDetails[i].select == true) {
        selectList.push({ classStd: classDetails[i].pkClassStandardsId })
      }
    }
    if (classDetails.length == selectList.length) {
      $("#className" + classDetails[0].pkClassStandardsId).attr("checked", true);
    }
    else {
      $("#className" + classDetails[0].pkClassStandardsId).attr("checked", false);
    }
    for (var j = 0; j < this.classAndSectionList.length; j++) {
      var status = $("#className" + this.classAndSectionList[j].ClassStandardsId).prop("checked");
      if (status == false) {
        this.classAndSectionList[j].select = false;
      }
      else {
        this.classAndSectionList[j].select = true;
      }
      if (this.classAndSectionList[j].select == true) {
        selectClassList.push({ classStd: this.classAndSectionList[j].ClassStandardsId })
      }
    }
    if (this.classAndSectionList.length == selectClassList.length) {
      this.allClass = true;
    }
    else {
      this.allClass = false;
    }
  }
  allClass = false;
  checkingSelect() {
    var selectList = [];
    for (var i = 0; i < this.classAndSectionList.length; i++) {
      if (this.classAndSectionList[i].select == true) {
        selectList.push({ classStd: this.classAndSectionList[i].ClassStandardsId })
      }
    }
    if (this.classAndSectionList.length == selectList.length) {
      this.allClass = true;
    }
    else {
      this.allClass = false;
    }
  }
  selectAllSectionOfClass(sectionList) {
    var isSel = $("#className" + sectionList[0].pkClassStandardsId).prop("checked");
    for (var i = 0; i < sectionList.length; i++) {
      sectionList[i].select = isSel;
    }
  }

  classAndSectionList = [];
  fetchClassStandardAndSection() {
    this.classAndSectionList = [];
    this.boardName = "";
    this.evalType = "0";
    this.allClass = false;
    this.gradeConfigButton = false;
    this.applyGradingSystem = false;
    this.offcanvas.handleOffcanvasOpen('#createExamBoardPopup_V2');
    this.settingservice.fetchClassStandardAndSectionService(this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.classAndSectionList = data;
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  sectionListOfClass = [];
  fetchClassSection(classStdId) {
    this.sectionListOfClass = classStdId;
    this.allSection = false;
  }
  async classStdSectionList() {
    var sectionArray = [];
    for (var i = 0; i < this.sectionListOfClass.length; i++) {
      if (this.sectionListOfClass[i].select) {
        sectionArray.push({ classId: this.sectionListOfClass[i].classId })
      }
    }
    if (sectionArray.length == 0) {
      const pleaseSelectAtleastOneClassSectionTranslation = await firstValueFrom(this.translate.get('pleaseSelectAtleastOneClassSection')); 
      customToastr(pleaseSelectAtleastOneClassSectionTranslation, 'error');
    }
    else {
      $("#sectionList" + this.sectionListOfClass[0].pkClassStandardsId).css({
        'color': 'green'
      });
      $("#closeSectionPopup").trigger("click");
    }
  }
  async configExamBoard() {
    var classListArray = [];
    for (var i = 0; i < this.classAndSectionList.length; i++) {
      for (var j = 0; j < this.classAndSectionList[i].section.length; j++) {
        if (this.classAndSectionList[i].section[j].select == true) {
          classListArray.push({ classStandardId: this.classAndSectionList[i].ClassStandardsId, classId: this.classAndSectionList[i].section[j].classId })
        }

      }
    }
    if (!this.formValidator.validateIsDataForNumber(this.boardName)) {
      const pleaseEnterBoardNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterBoardName')); 
      customToastr(pleaseEnterBoardNameTranslation, 'error');
      return;
    }
    if (this.evalType == "0") {
      const pleaseSelectEvaluationTypeTranslation = await firstValueFrom(this.translate.get('pleaseSelectEvaluationType')); 
      customToastr(pleaseSelectEvaluationTypeTranslation, 'error');
      return;
    }
    if (classListArray.length == 0) {
      const pleaseSelectAtleastOneClassTranslation = await firstValueFrom(this.translate.get('pleaseSelectAtleastOneClass')); 
      customToastr(pleaseSelectAtleastOneClassTranslation, 'error');
      return;
    }
    if (this.evalType == 'MARKS') {
      this.configGrade = [];
    }
    var examBoardData = {
      BoardName: this.boardName,
      EvaluationType: this.evalType,
      classList: classListArray,
      gradingData: this.configGrade
    };
    $("#configButton").attr("disabled", true);
    $("#cancelconfig").attr("disabled", true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#configButton').text(translatedText); });
    this.settingservice.createGradingSystemConfigService(examBoardData, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          $("#configButton").attr("disabled", false);
          $("#cancelconfig").attr("disabled", false);
          this.translate.get('configure').subscribe((translatedText: string) => { $('#configButton').text(translatedText); });
          if (data.status == true) {
            const examBoardCreatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('examBoardCreatedSuccessfully')); 
            customToastr(examBoardCreatedSuccessfullyTranslation, 'success');
            $("#cancelconfig").trigger("click");
            this.getExamBoard();
          }
          else if (data.status == false) {
            const examBoardNameAlreadyExistPleaseEnterOtherNameTranslation = await firstValueFrom(this.translate.get('examBoardNameAlreadyExistPleaseEnterOtherName')); 
            customToastr(examBoardNameAlreadyExistPleaseEnterOtherNameTranslation, 'error');
          }
          else {
            const examBoardNotCreatedSuccessfullyPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('examBoardNotCreatedSuccessfullyPleaseTryAgain')); 
            customToastr(examBoardNotCreatedSuccessfullyPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          $("#configButton").attr("disabled", false);
          $("#cancelconfig").attr("disabled", false);
          this.translate.get('configure').subscribe((translatedText: string) => { $('#configButton').text(translatedText); });
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  async gradeSystemConfig() {
    for (var i = 0; i < this.configGrade.length; i++) {
      if (!this.formValidator.validateIsDataForNumber(this.configGrade[i].minMarks)) {
        const pleaseEnterMinimumMarksTranslation = await firstValueFrom(this.translate.get('pleaseEnterMinimumMarks')); 
        customToastr(pleaseEnterMinimumMarksTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.configGrade[i].maxMarks)) {
        const pleaseEnterMaximumMarksTranslation = await firstValueFrom(this.translate.get('pleaseEnterMaximumMarks')); 
        customToastr(pleaseEnterMaximumMarksTranslation, 'error');
        return;
      }
      if (parseInt(this.configGrade[i].minMarks) >= parseInt(this.configGrade[i].maxMarks)) {
        const maximumMarksShouldBeGreaterThanMinimumMarksTranslation = await firstValueFrom(this.translate.get('maximumMarksShouldBeGreaterThanMinimumMarks')); 
        customToastr(maximumMarksShouldBeGreaterThanMinimumMarksTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.configGrade[i].grade)) {
        const pleaseEnterGradeNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterGradeName')); 
        customToastr(pleaseEnterGradeNameTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsDataForNumber(this.configGrade[i].gradePoint)) {
        const pleaseEnterGradePointTranslation = await firstValueFrom(this.translate.get('pleaseEnterGradePoint')); 
        customToastr(pleaseEnterGradePointTranslation, 'error');
        return;
      }
    }
    this.applyGradingSystem = false;
    $("#configGradeCloseButton").trigger("click");
  }
  examBoardList = [];
  getExamBoard() {
    this.examBoardList = [];
    this.destroyDataTable('examBoardTable');
    this.settingservice.getExamBoardService(this.getAuthToken)
      .subscribe(
        data => {
          this.examBoardList = data[0];
          this.initializeDataTableOrder('examBoardTable');
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  classListByExamBoard = [];
  selectedExamBoardName = "";
  selectedExamBoardId;
  boardEvaluationType = "";
  getClassListByExamBoard(board) {
    this.selectedExamBoardId = board.pkSchoolExamBoardId;
    this.classListByExamBoard = [];
    this.boardEvaluationType = board.EvaluationType;
    this.offcanvas.handleOffcanvasOpen('#offcanvasViewExamBoard');
    this.settingservice.getClassListByExamBoardService(this.selectedExamBoardId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.classListByExamBoard = data;
          this.selectedExamBoardName = this.classListByExamBoard[0].ExamBoardName;
          $("#tableSectionHeader").attr('colspan', this.classListByExamBoard[0].classList.length)
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }
  gradeSystemArray = [];
  getExamGradeConfigByExamBoard(boardId) {
    this.gradeSystemArray = [];
    this.settingservice.getExamGradeSystemByExamBoardService(boardId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.gradeSystemArray = data;
        },
        async error => {
          const internalServerErrorTranslation = await firstValueFrom(this.translate.get('internalServerError')); 
          customToastr(internalServerErrorTranslation, 'error');
        }
      );
  }

  getAcademicList(schoolId) {
    this.isPageLoading = true
    this.schoolAcademicList = [];
    this.settingservice.fetchAcademicList(schoolId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          for (const item of data.academicList) {
            // this.schoolAcademicList.push(item);
            if (item.InActive === 0) {
              this.schoolAcademicCurrent.push(item);
              this.academicId = item.pkAcademicId;
              this.schoolAcademicCurrentYear = item.Year;
            }
          }
          data = data.academicList;
          if (data && data.length > 0) {
            this.academicInfo.academicList = data;
            let indexOfCurrent = null;
            for (let i = 0; i < this.academicInfo.academicList.length; i++) {
              this.academicInfo.academicList[i].current = false;
              this.academicInfo.academicList[i].notstarted = false;
              this.academicInfo.academicList[i].completed = false;
              if (this.academicInfo.academicList[i].InActive === 0) {
                indexOfCurrent = i;
                this.academicInfo.academicList[i].current = true;
                this.academicInfo.current_academic = this.academicInfo.academicList[i].pkAcademicId;
                this.academicInfo.year = this.academicInfo.academicList[i].Year;
                this.academicInfo.current_academic_state = this.academicInfo.academicList[i].current ?
                  'RUNNING' : this.academicInfo.academicList[i].completed ? 'COMPLETED' : 'NOT_STARTED';
              } else if (this.academicInfo.academicList[i].InActive === 1) {
                const sDate = new Date(this.academicInfo.academicList[i].StartDate);
                const eDate = new Date(this.academicInfo.academicList[i].EndDate);
                if (eDate < new Date()) {
                  this.academicInfo.academicList[i].completed = true;
                } else {
                  this.academicInfo.academicList[i].notstarted = true;
                }
              }
            }
          }
          $('body').find("#multiple-id-cards-trigger").attr("selected-academic", this.academicInfo.current_academic);
          this.getInactiveStudentList()
        },
        error => {
        }
      );
  }

  academicChanged() {
    $('#deactstudentable_filter input[type="search"]').val('');
    for (const item of this.academicInfo.academicList) {
      if (item.pkAcademicId === this.academicInfo.current_academic) {
        this.academicInfo.year = item.Year;
        this.academicInfo.current_academic_state = item.current ? 'RUNNING' : item.completed ? 'COMPLETED' : 'NOT_STARTED';
      }
    }
    $("body").find("#multiple-id-cards-trigger").attr("selected-academic", this.academicInfo.current_academic);
    this.getInactiveStudentList()
    // this.initDataTableServerProcess('groups-student-list', this.getSchoolId, this.getAuthToken, this.academicInfo.current_academic,
    //   this.selectedCategory, this.selectedClass, this.selectedSection);
  }


  /*MANAGE BOARD END HERE*/

  async getSchoolSettingsList() {
    try {
      const data = await firstValueFrom(
        this.settingservice.fetchSchoolSettings(this.getAuthToken)
          .pipe(
            map((response: any) =>
              response
            )
          )
      );
      if (data && data?.body?.schoolSettings[0]) {
        this.markAttendanceAfterCheckin = data?.body?.schoolSettings[0]?.markStudentAttendanceAfterCheckIn == 1 ? true : false;
      } else {
        const failedToUpdateSettingTranslation = await firstValueFrom(this.translate.get('failedToFetchSetting'));
        customToastr(failedToUpdateSettingTranslation, 'error');
      }
    } catch (error) {
      const failedToUpdateSettingTranslation = await firstValueFrom(this.translate.get('failedToFetchSetting'));
      customToastr(failedToUpdateSettingTranslation, 'error');
    }
  }

  async updateMarkAttendanceAfterCheckIn(value) {
    try {
      this.isMarkAttedanceAfterCheckInUpdating = true;
      const body = {
        markStudentAttendanceAfterCheckIn: value,
        lang: "en"
      };
      const response = await firstValueFrom(this.settingservice.setSchoolSettings(body, this.getAuthToken));
      const responseDetails = response as any;
      if (responseDetails && responseDetails.status == true) {
        this.isMarkAttedanceAfterCheckInUpdating = false;
        this.markAttendanceAfterCheckin = value;
        const schoolSettingUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('settingUpdated'));
        customToastr(schoolSettingUpdatedSuccessfullyTranslation, 'success');
      } else {
        const failedToUpdateSettingTranslation = await firstValueFrom(this.translate.get('failedToUpdateSetting'));
        customToastr(failedToUpdateSettingTranslation, 'error');
        this.isMarkAttedanceAfterCheckInUpdating = false;
      }
    } catch (error) {
      const failedToUpdateSettingTranslation = await firstValueFrom(this.translate.get('failedToUpdateSetting'));
      customToastr(failedToUpdateSettingTranslation, 'error');
      this.isMarkAttedanceAfterCheckInUpdating = false;
    }

  }
}